import { nanoid } from 'nanoid';
import { getHash } from './url';

export function insertAfter(newNode, referenceNode) {
  referenceNode.parentNode.insertBefore(newNode, referenceNode.nextSibling);
}

export function setAriaLabelledBy($element, $label) {
  $label.id = `id-${nanoid()}`;
  $element.setAttribute('aria-labelledby', $label.id);
}

export function scrollToDOMNode() {
  const id = getHash(window.location.href);

  if (id.length > 1) {
    const $node = _$(`${id}`);

    if ($node) {
      try {
        setTimeout(() => {
          const scrollTop =
            window.pageYOffset || document.documentElement.scrollTop;
          const { top } = $node.getBoundingClientRect();
          const offset = 40;

          window.scrollTo({
            top: scrollTop + top - offset,
            behavior: 'smooth'
          });
        }, 800);
      } catch (e) {
        console.log('An error ocurred when scrolling to anchor.');
      }
    }
  }
}
